import { default as color } from './colors';
import { default as easing } from './easing';
import { default as countries } from './countries';
import { default as media } from './media';
import { default as unit } from './units';
export { default as color } from './colors';
export { default as easing } from './easing';
export { default as countries } from './countries';
export { default as media } from './media';
export { default as unit } from './units';

export default {
  color,
  easing,
  countries,
  media,
  unit,
};



// WEBPACK FOOTER //
// ./src/styles/index.js